import {
  GET_SOURCE_VALUES,
} from 'constants/sourceValues';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_SOURCE_VALUES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
